import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import AddJobAllJobsProfile from "../../StylesWrappers/General/AddJobAllJobsProfile";
import InputSection from "../../components/AllJobs/InputSection";
import ShowAllJobs from "../../components/AllJobs/ShowAllJobs";
import TitleText from "../../components/General/Helmet";
import { AppDispatch, RootState } from "../../store";
import {
  allJobsAction,
  clearInputs,
  collectInputs,
  decreasePage,
  increasePage,
  jobsPerPage,
  searchForJobs,
} from "../../features/allJobs/allJobsSlice";
import { Pagination } from "../../components/General/helpers";
import { addQueryParams } from "../../utils/queryParams";
import JobCardSkeleton from "../../components/Skeletons/JobCardSkeleton";
import AllJobsWrapper from "../../StylesWrappers/AllJobs/showAllJobs";

const AllJobs = () => {
  const {
    allJobsInputs,
    allJobs,
    jobCount,
    currentPage,
    pageSize,
    totalPages,
  } = useSelector((store: RootState) => store.allJobsStore);
  const { isLoading } = useSelector((store: RootState) => store.allJobsStore);
  const { statLoading } = useSelector((store: RootState) => store.statStore);

  const { search, status, type } = allJobsInputs;

  const [isJobPage, setIsJobPage] = useState(false);

  const dispatch: AppDispatch = useDispatch();
  const { pathname } = useLocation();

  // Handle input change
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name;
    let value = e.target.value;
    dispatch(collectInputs({ name, value }));
  };

  // Handle select change
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let name = e.target.name;
    let value = e.target.value;
    dispatch(collectInputs({ name, value }));
  };

  // Clear input field
  const handleClear = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearInputs());
  };

  // Go to next page
  const handleNextButton = () => {
    dispatch(increasePage());
  };

  // Go to previous page
  const handlePreviousButton = () => {
    dispatch(decreasePage());
  };

  // Set the number of jobs to see per page
  const handleClickPage = (value: number) => {
    // console.log(value);
    dispatch(jobsPerPage(value));
    setIsJobPage(false);
  };

  // INCLUDE THE URL WITH THE LIMIT AND PAGE NUMBERS
  useEffect(() => {
    addQueryParams(pathname, currentPage, pageSize);
  }, [pathname, currentPage, pageSize]);

  // Fetch all jobs
  useEffect(() => {
    dispatch(clearInputs()); // Clear serach input before calling all jobs
    dispatch(allJobsAction({ currentPage, pageSize }));
  }, [currentPage, pageSize, dispatch]);

  // INTIATE SEARCH WHEN SEARCH, STATUS VALUE OR TYPEVALUE CHANGES
  useEffect(() => {
    dispatch(searchForJobs({ search, status, type }));
  }, [search, status, type, dispatch]);

  // Loading state for all jobs
  if (isLoading || statLoading) {
    return <JobCardSkeleton cards={4} />;
  }

  // Display no job for zero all jobs
  if (jobCount === 0) {
    return (
      <AllJobsWrapper>
        <p className="no__job">NO JOBS TO DISPLAY</p>
      </AllJobsWrapper>
    );
  }

  return (
    <>
      <AddJobAllJobsProfile>
        <TitleText title="Jobtrackier - All Jobs" />
        {/* <p>Search Form</p> */}
        <InputSection
          search={search}
          status={status}
          type={type}
          searchName="search"
          typeName="type"
          statusName="status"
          handleChange={handleChange}
          handleSelect={handleSelect}
          handleClear={handleClear}
        />
      </AddJobAllJobsProfile>
      <ShowAllJobs allJobsProps={allJobs} countCheck={jobCount} />
      <Pagination
        handlePreviousButton={handlePreviousButton}
        handleNextButton={handleNextButton}
        handleClickPage={handleClickPage}
        isJobPage={isJobPage}
        setIsJobPage={setIsJobPage}
        currentPage={currentPage}
        pageSize={pageSize}
        totalPages={totalPages}
      />
    </>
  );
};

export default AllJobs;
